import { type MCPServerInfo } from '../../types';

const SpinachServer: MCPServerInfo = {
  serverId: 'SPINACH',
  name: 'Spinach',
  slug: 'spinach',
  description:
    'Query insights and transcripts from your recent Spinach meetings via OAuth.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.spinach.ai/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default SpinachServer;
